import { Button } from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

function SessionTimeoutHandler() {
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  }, [navigate]);

  const checkTokenExpiration = useCallback(() => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      handleLogout();
      return;
    }

    try {
      const tokenParts = accessToken.split(".");
      if (tokenParts.length !== 3) {
        handleLogout();
        return;
      }

      const payload = JSON.parse(atob(tokenParts[1]));
      const expirationTime = payload.exp * 1000;
      const currentTime = Date.now();

      if (currentTime >= expirationTime) {
        handleLogout();
      } else if (expirationTime - currentTime <= 30000) {
        setShowModal(true);
        setCountdown(Math.floor((expirationTime - currentTime) / 1000));
      }
    } catch (error) {
      console.error("Error checking token expiration:", error);
      handleLogout();
    }
  }, [handleLogout]);

  useEffect(() => {
    checkTokenExpiration();

    const intervalId = setInterval(checkTokenExpiration, 10000);

    return () => clearInterval(intervalId);
  }, [checkTokenExpiration]);

  useEffect(() => {
    let interval: any;

    if (showModal && countdown > 0) {
      interval = setInterval(() => {
        setCountdown((seconds) => seconds - 1);
      }, 1000);
    } else if (countdown === 0) {
      handleLogout();
    }

    return () => clearInterval(interval);
  }, [showModal, countdown, handleLogout]);

  const refreshSession = async () => {
    try {
      setShowModal(false);
      setCountdown(30);
    } catch (error) {
      console.error("Failed to refresh session:", error);
      handleLogout();
    }
  };

  const WarningModal = () => (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "5px",
        }}
      >
        <h2>Session Timeout</h2>
        <p>Your session will expire in {countdown} seconds.</p>
        <div className="flex width-100">
          <Button variant="contained" onClick={handleLogout}>
            Logout Now
          </Button>
        </div>
      </div>
    </div>
  );

  return <div>{showModal && <WarningModal />}</div>;
}

export default SessionTimeoutHandler;
